import React from 'react'
import Hero from '../Components/Hero/Hero'
import Collection from '../Components/Collection/Collection'
import Popular from '../Components/Popular/Popular'
import Patterns from '../Components/Patterns/Patterns'
import Accessories from '../Components/Accessories/Accessories'
import PromoBar from '../Components/PromoBar/PromoBar'

const Home = () => {
  return (
    <div>
      <PromoBar />
      <Popular />
      <Hero />
      <Patterns />
      <Accessories />
      <Collection />
    </div>
  )
}

export default Home